import { Attachment, FileViewer } from '@cellula/react';
import { FileWorker, FileWorkerStale, WorkerTaskState } from '@feature/file_manager/mod';
import { usePresentation } from '@visiba/presentation';
import { formatBytes } from '@visiba/std';

interface Props {
	worker: FileWorker | FileWorkerStale;
	onRemoveClick?: (fileId: string) => void;
}

export function AttachedFile({ onRemoveClick, worker }: Props) {
	const presentation = usePresentation(worker.presentation);
	const isStale = worker instanceof FileWorkerStale;

	function handleDelete(): void {
		onRemoveClick?.(worker.id);
	}

	return (
		<>
			<FileViewer.Item file={worker} asChild>
				<Attachment
					name={worker.fileName}
					meta={formatBytes(worker.fileSize, 1)}
					onDelete={onRemoveClick != null && !isStale ? handleDelete : undefined}
					loading={presentation.fileState === WorkerTaskState.Uploading}
					invalid={!!presentation.failedReason}
					invalidText={presentation.failedReason ?? undefined}
					preview={worker.getThumbnail() ?? undefined}
				/>
			</FileViewer.Item>
		</>
	);
}
